export default __webpack_public_path__ + "static/LeituraTwo-Roman-362c8ddbc21fc59d88177570c7aa823a.woff";